import * as React from 'react';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { UIHeading5 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';

import { Button } from '../../components/Button';
import { DEVELOPER_ID } from '../../constants';
import { getFilterLocation, getPhone, getUser, getUserPhone } from '../../selectors';
import { ECallbackPlace } from '../../types/callback';
import { getTimezoneByRegionId } from '../../utils';
import { createGaUser, createLabel } from '../../utils/analytics';
import { NewbuildingCallbackWidgetContext } from '../NewbuildingCallbackWidgetProvider';
import { getUserIdByLocation } from './helpers';

interface ICallbackProps {
  place: ECallbackPlace;
}

export function Callback({ place }: ICallbackProps) {
  const [isLoading, setLoading] = React.useState(false);
  const location = useSelector(getFilterLocation);
  const userPhoneNumber = useSelector(getUserPhone);
  const user = useSelector(getUser);
  const agentPhone = useSelector(getPhone);

  const timezoneOffset = getTimezoneByRegionId(location);
  const builderRealtyUserId = getUserIdByLocation(location);

  const openWidget = React.useContext(NewbuildingCallbackWidgetContext);

  const handlePopupOpen = React.useCallback(async () => {
    if (!agentPhone || !builderRealtyUserId) {
      return;
    }

    setLoading(true);

    await openWidget({
      agentPhone,
      timezoneOffset,
      userPhoneNumber,
      builderRealtyUserId,
      theme: 'pik',
      trackingParams: {
        category: 'CardBuilder',
        opener: place,
        gaLabel: createLabel(DEVELOPER_ID),
        user: createGaUser(user),
      },
    });

    setLoading(false);
  }, [openWidget, agentPhone, builderRealtyUserId, timezoneOffset, userPhoneNumber, user, place]);

  if (!agentPhone || !builderRealtyUserId) {
    return null;
  }

  return (
    <Button
      size="small"
      icon={<IconCommunicationPhone16 color="icon-inverted-default" />}
      onClick={handlePopupOpen}
      testId="CallbackFormButton"
      disabled={isLoading}
    >
      <UIHeading5 color="text-inverted-default">Обратный звонок</UIHeading5>
    </Button>
  );
}
